import { Select, SelectProps } from "antd";
import { useGetLanguagesQuery } from "api/TenantSlug/Language/hooks";
import {CountryCell} from "components/UI/Table/UI/CountryCell/CountryCell.tsx";
import {usePaldockTranslation} from "hooks/usePaldockTranslation.tsx";


type LanguageSelectSearchableProps = Partial<SelectProps<number>>;

export const LanguageSelectSearchable: React.FC<LanguageSelectSearchableProps> = (props) => {
    const { data, isLoading } = useGetLanguagesQuery();
    const { t } = usePaldockTranslation("ui.selects.language_select_searchable");

    const options = (data?.languages ?? []).map((lang) => ({
        label: (
            <span className="flex items-center gap-2">
                <CountryCell country={lang} /> {lang.name}
            </span>
        ),
        value: lang.id,
        searchLabel: lang.name,
    }));

    return (
        <Select
            showSearch
            loading={isLoading}
            placeholder={t("placeholder")}
            options={options}
            optionFilterProp="label"
            filterOption={(input, option) =>
                (option?.searchLabel?.toString() ?? "").toLowerCase().includes(input.toLowerCase())
            }
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
